import clsx from 'clsx';
import { createElement } from 'react';

import { Content } from '@/lib';
import { CopyLink } from '@/components';
import styles from './Header.module.scss';
import { Row } from '../../Row';

export function Header({ text, level, elementId, fluid }: Content.WithFluid<Content.Header>) {
  if (!elementId) {
    throw new Error('Missing elementId for header');
  }
  const tag = `h${level}`;

  return (
    <Row className={clsx(fluid && styles.fluid)}>
      {createElement(
        tag,
        {
          id: elementId,
          className: clsx(styles.header, styles[tag], tag),
        },
        <>
          <span>{text}</span>
          <CopyLink id={elementId} className={styles.copy} />
        </>
      )}
    </Row>
  );
}
